import { useState } from "react";
import INTOUCH_API from "../../../../services/Api";
import { getFormInputsValue } from "../../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import useValidateForm from "../../../../hooks/useValidateForm";

export default function useController() {
  const { isValidEmail, manageValidate } = useValidateForm();
  const [errorMessage, setErrorMessage] = useState("");
  const [isEmailSending, setIsEmailSending] = useState(false);
  const [email, setEmail] = useState("");
  const [mailForm, setMailForm] = useState({
    email: "",
  });

  const navigate = useNavigate();

  const onSubmitEmailHandle = async (event) => {
    if (isEmailSending) return;
    event.preventDefault();
    const formData = getFormInputsValue(event.target.elements);
    formData.email = formData.email.toLowerCase();
    setEmail(formData.email.toLowerCase());
    await sendEmail(formData);
    event.target.value = "";
  };
  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    manageValidate(name, value);
    setMailForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const sendEmail = async (formData) => {
    setIsEmailSending(true);
    INTOUCH_API.requestManager(
      "email",
      formData,
      (response) => {
        localStorage.setItem("recoveryEmail", formData.email.toLowerCase());
        navigate("code");
      },
      (error) => {
        setErrorMessage(error?.response?.data.message);
      }
    ).finally(() => {
      setIsEmailSending(false);
    });
  };

  return {
    onSubmitEmailHandle,
    isEmailSending,
    email,
    errorMessage,
    mailForm,
    onChange,
    isValidEmail,
  };
}
